export enum RegistrationStatus {
  Registered = "Registered",
  Tentative = "Tentative",
  Declined = "Declined",
  Cancelled = "Cancelled",
  Attended = "Attended",
}

export enum MealPreference {
  None = "None",
  Meat = "Meat",
  Vegetarian = "Vegetarian",
  Vegan = "Vegan",
  Flex = "Flex",
  NoMeal = "NoMeal",
}

export enum EventStatus {
  Active = "Active",
  Cancelled = "Cancelled",
  Completed = "Completed",
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  errors?: string[];
  message?: string;
  count?: number;
}

export interface SimpleApiResponse {
  success: boolean;
  error?: string;
  message?: string;
}

export interface ApiError {
  error: string;
}

export interface EventRegistration {
  partitionKey: string;
  rowKey: string;
  registrationId: string;
  eventId: string;
  userId?: string;
  userEmail: string;
  userName: string;
  employeeId?: string;
  sector?: string;
  cluster?: string;
  mealPreference: MealPreference;
  registrationDate: string;
  status: RegistrationStatus;
  checkInCode?: string;
  checkInTime?: string;
  checkedInBy?: string;
  createdAt: string;
  lastModified: string;
  notes?: string;
  guestCount?: number;
  additionalAdults?: number;
  additionalChildren?: number;
}
